export const inr = (v) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(v || 0));

export const inrFull = (v) => `₹${inr(v)}`;

export const inrCompact = (v) => {
  const n = Math.abs(v || 0);
  if (n >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  if (n >= 1e3) return `₹${(v / 1e3).toFixed(1)} K`;
  return `₹${Math.round(v || 0)}`;
};

export const prettyLoc = (loc) => {
  if (!loc) return "";
  return loc
    .replace(" FRCHS", "")
    .toLowerCase()
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

export const CAT_COLORS = {
  gold: "#D4AF37",
  diamond: "#0EA5E9",
  precious: "#9D4EDD",
  silver: "#94A3B8",
};

export const LOC_COLORS = ["#0F172A", "#D4AF37", "#0EA5E9", "#9D4EDD", "#DC2626", "#059669"];
